/** The handle of every e-commerce toast, the one the screens' notice had. */
export const ECOMMERCE_NOTICE = 'ecommerce-notice';

/**
 * The toasts of the seller's integrations. A toast outlives the page, which is
 * what lets a deletion from the detail still be announced on the listing it
 * goes back to. See `feedbackCatalog` for what each field means.
 */
export const ECOMMERCES_FEEDBACK_RULES = {
  'ecommerces/createIntegration': { success: 'Integración creada', testId: ECOMMERCE_NOTICE },
  'ecommerces/updateIntegration': { success: 'Cambios guardados', testId: ECOMMERCE_NOTICE },
  'ecommerces/deleteIntegration': { success: 'Integración eliminada', testId: ECOMMERCE_NOTICE },
};
